<script>
import Dialog from "../Dialog/index.vue";
import {initCanvas, initCanvas2x} from "../../canvas/lightning";

export default {
  name: "PreviewSvga",
  components: {Dialog},
  data() {
    return {
      src: undefined,
      visible: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.src.includes('svga')) {
        const {windowWidth, windowHeight} = uni.getSystemInfoSync()
        const maxWidth = parseInt(windowWidth * 0.8)
        const maxHeight = parseInt(windowHeight * 0.8)
        uni.showLoading({mask: false})
        initCanvas2x('#preview-svga', this.src, maxWidth, maxHeight, 'preview-canvas').then(uni.hideLoading)
      }
    })
  },
  methods: {
    close(){
      this.visible = false
      uni.hideLoading()
    }
  }
}
</script>

<template>
  <Dialog v-model='visible'>
    <img class='prev-image' v-if='!this.src.includes("svga")' :src='this.src' alt=''>
    <view v-else id='preview-svga' @click='visible = false'></view>
  </Dialog>
</template>

<style scoped lang="scss" scoped>
#preview-svga {
  width: 80vw;
  height: 80vh;
}

.prev-image {
  max-width: 80vw;
}
</style>
